import * as React from 'react';
import cn from 'clsx';
import * as styles from './styles.css';

import { Button } from '@cian/ui-kit';

import { Container } from '../Container';
import { Text } from '../Text';
import { trackLeaveClick } from '../../analytics';

export interface IStickHeaderProps {
  isVisible: boolean;
  onClick(): void;
}

export function StickHeader({ isVisible, onClick }: IStickHeaderProps) {
  return (
    <div className={cn(styles['container'], isVisible && styles['visible'])}>
      <Container>
        <div className={styles['content']}>
          <Text color="black">
            Предоставим доступ к данным о рынке недвижимости. Создадим уникальные модели и подготовим отчеты
          </Text>
          <Button
            size="M"
            theme="fill_primary"
            onClick={() => {
              trackLeaveClick();
              onClick();
            }}
          >
            Оставить заявку
          </Button>
        </div>
      </Container>
    </div>
  );
}
